<template>
  <div id="app">
    <router-view/>
    <!-- 右侧悬浮代办事项框 -->
    <!-- <TodoFloatBox ref="todoFloatBox"/> -->
    <!-- 登录后待办事项提示弹窗 -->
    <!-- <TodoNotification/> -->
    <!--通知弹窗-->
    <!-- <Todo/> -->
  </div>
</template>
<script>
import Todo from './components/Todo.vue'
// import TodoFloatBox from './components/TodoFloatBox.vue'
// import TodoNotification from './components/TodoNotification.vue'
export default {
  name: 'App',
  components: {
    // Todo,
    // TodoFloatBox,
    // TodoNotification
  }
}
</script>
<style>
#app {
  margin: 0;
  padding: 0;
  background: #F7F8FA;
  
}
</style>
